interface DocContentWrapperProps {
  variant: 'dashboard' | 'external';
  children: React.ReactNode;
  className?: string;
}

/**
 * Wraps shared doc content with variant-specific theming.
 *
 * - `dashboard`: applies scoped typography for bare heading/link/table tags
 * - `external`: maps tokens to light-theme colors for the external docs site
 */
export function DocContentWrapper({ variant, children, className = '' }: DocContentWrapperProps) {
  const variantClass = variant === 'external' ? 'doc-external-theme' : '';

  if (variant === 'dashboard') {
    return (
      <>
        <style>{`
          .doc-dashboard-prose h2 {
            font-size: 1.5rem;
            font-weight: 600;
            margin-top: 2.5rem;
            margin-bottom: 1rem;
            padding-bottom: 0.5rem;
            border-bottom: 1px solid var(--color-border, #e5e7eb);
          }
          .doc-dashboard-prose h2:first-child,
          .doc-dashboard-prose h3:first-child,
          .doc-dashboard-prose h4:first-child {
            margin-top: 0;
          }
          .doc-dashboard-prose h3 {
            font-size: 1.25rem;
            font-weight: 600;
            margin-top: 2rem;
            margin-bottom: 0.75rem;
          }
          .doc-dashboard-prose h4 {
            font-size: 1.125rem;
            font-weight: 600;
            margin-top: 1.5rem;
            margin-bottom: 0.5rem;
          }
          .doc-dashboard-prose a:not([class]) {
            color: var(--color-primary, #3b82f6);
          }
          .doc-dashboard-prose a:not([class]):hover {
            text-decoration: underline;
          }
          .doc-dashboard-prose table {
            border-collapse: collapse;
            font-size: 0.875rem;
          }
        `}</style>
        <div className={`doc-dashboard-prose ${className}`}>{children}</div>
      </>
    );
  }

  return (
    <>
      <style>{`
        .doc-external-theme {
          --color-primary: #3581cf;
          --color-text-primary: #111827;
          --color-text-secondary: #4B5563;
          --color-card-bg: #ffffff;
          --color-border: #E5E7EB;
          --color-hover-bg: #F9FAFB;
        }
      `}</style>
      <div className={`${variantClass} ${className}`}>{children}</div>
    </>
  );
}
